<template>
	<div> {{ unixPhotodate }}</div>
</template>
